module.exports = __webpack_public_path__ + "static/media/Men_1.5470fed1.jpeg";